<!-- 维权联系方式页面 -->
<template>
  <div class="contactInformation">
    <div class="nav-top">
      <i class="iconfont icon-zglsfanhui" @click="toIndex()"></i>
      各省（区、市）{{type === 'RPM' ? '维权' : '投诉'}}中心联络方式
    </div>

    <div class="detail-content">
      <div class="catalog-title" v-if="catalogInfo && catalogInfo.properties">{{catalogInfo.properties.abbreviation}}</div>
      <div class="catalog-item" v-if="catalogInfo && catalogInfo.properties">
        <div class="catalog-item-label">联系电话</div>:&nbsp;{{catalogInfo.properties.contactMobile}}</div>
      <div class="catalog-item" v-if="catalogInfo && catalogInfo.properties">
        <div class="catalog-item-label">邮&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;箱</div>:&nbsp;{{catalogInfo.properties.contactMail}}</div>
      <div class="catalog-item" v-if="catalogInfo && catalogInfo.properties">
        <div class="catalog-item-label">网&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</div>:&nbsp;{{catalogInfo.properties.contactSite}}</div>
      <div class="catalog-item" v-if="catalogInfo && catalogInfo.properties">
        <div class="catalog-item-label">地&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址</div>:&nbsp;{{catalogInfo.properties.contactAddress}}</div>
      <div class="city-item" v-for="(item,index) in provinceList" :key="index" @click="toDetail(item.id,item.name)">{{item.name}}</div>
    </div>
  </div>
</template>

<script>
import api from "../api/index";

export default {
  data() {
    return {
      type:'',
      code: "",
      codeUrl: "/captchacircle",
      provinceList:[],
      catalogInfo:{}
    };
  },
  created() {
    if (this.$route.params) {
      this.type = localStorage.getItem('rightType')
      this.from = this.type === 'RPM' ? 'rightProtection' : 'complainView';
    }
    this.getProvinceList();
    this.getCatalogInfo();
  },
  methods: {
    toIndex() {
      this.$router.push({
        name: this.from,
      });
    },
    toDetail(id,name){
      this.$router.push({
        name: 'contactDetail',
        params:{
          provinceId: id,
          name: name,
          type: this.type
        }
      });
    },
    getProvinceList() {
      api.getProvinceList().then((res) => {
        if (res.data.code === 1) {
          this.provinceList = res.data.result
        }else {
          this.$message.error(res.data.description)
        }
      });
    },

    getCatalogInfo() {
      let params = {};
      if (this.type === 'RPM') {
        params.catalogId = "9a7d3ab20aa64f249f0eb149dd015d27"
      } else {
        params.catalogId = "02655d24c97c4242a0642f775495b246"
      }
      api.getCatalogInfo(params).then((res) => {
        if (res.data.code === 1) {
          this.catalogInfo = res.data.result;
        } else {
          this.$message.error(res.data.description);
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.contactInformation {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f4f6fa;
  .nav-top {
    position: relative;
    width: 100%;
    height: 2.75rem;
    background: #fff;
    text-align: center;
    font-weight: 600;
    font-size: 1.06rem;
    color: #323233;
    line-height: 2.75rem;
    .iconfont {
      position: absolute;
      left: 1rem;
      top: 0;
      font-size: 1.25rem;
      color: #323233;
    }
  }
  .detail-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 0.63rem;
    width: 100%;
    max-height: calc(100% - 2.75rem);
    padding: 2.5rem 1rem;
    box-sizing: border-box;
    background: #fff;
    overflow: auto;
    .city-item {
      // margin: 0 1.56rem 1.13rem 0;
      // width: 8.5rem;
      margin-top: 1rem;
      width: 9.5rem;
      height: 3rem;
      text-align: center;
      background: #f4f6fa;
      border-radius: 0.13rem;
      font-weight: 400;
      font-size: 1rem;
      color: rgba(0, 0, 0, 0.65);
      line-height: 3rem;
    }
  }
  .catalog-title {
    font-size: 0.98rem;
    font-weight: 600;
    margin-bottom: 0.63rem;
  }
  .catalog-item {
    display: flex;
    width: 100%;
    line-height:1.38rem;
    font-size: 0.88rem;
    margin-bottom: 0.63rem;
  }
  .catalog-item-label {
    width: 3.8rem;
    text-align: center;
  }
}
</style>
